<template>
	<div class="instagram-card" @click="onClick" @mouseenter="onHover(true)" @mouseleave="onHover(false)">
		<div class="anchor">
			<div class="image" :style="{backgroundImage: `url('${data.src}')`}"></div>
			<div class="content" :class="{show: bHover}">
				<div class="title">{{ data.title }}</div>
				<div class="action-bar">
					<div class="likes">
						<span>{{ data.likes || 0 }}</span>
					</div>

					<div class="comments">
						<span>{{ data.comments || 0 }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'instagram-card',

	props: {
		data: {
			type: Object,
			required: true
		}
	},

	data() {

		return {
			bHover: 0,
		}
	},

	methods: {
		onClick() {

			if (window.screen.width > 1024 || this.bHover > 1)
				window.open(this.data.href, '_blank') || 'https://instagram.com/eximus_performance'
			else
				this.bHover = 2
		},

		onHover(bHover) {

			if (!bHover)
				this.bHover = 0
			else if (window.screen.width > 1024)
				this.bHover = 1
		}
	}
}
</script>

<style lang="stylus" scoped>
.instagram-card
	position relative

	padding-bottom 100%

	cursor pointer

	.anchor
		width 100%
		height 100%
	
		position absolute
		top 0
		left 0
		z-index 1

		.image
			width 100%
			height 100%

			position absolute
			top 0
			left 0
			z-index 1

			background-image linear-gradient(to right, darkish, dark)
			background-size cover
			background-position center
		
		.content
			width 100%
			height 100%

			display grid
			grid-template-columns auto
			grid-template-rows 1fr auto

			position absolute
			left 0
			bottom 0
			z-index 2

			margin-bottom -0.5em
			padding 1em
			box-sizing border-box

			opacity 0

			background-image linear-gradient(to bottom, rgba(dark, 0.4), rgba(darker, 0.8))

			transition 0.2s ease

			&.show
				margin-bottom 0

				opacity 1

			.title
				height 100%

				padding 0.2em

				overflow-y scroll
				-webkit-overflow-scrolling touch

				font-size 1.1em

				user-select none
			
			.action-bar
				display flex
				justify-content space-between
				align-items center

				margin-top 0.5em

				user-select none

				.likes
				.comments
					font-weight bold

					&:before
						display inline-block

						margin-right 0.2em

						font-family 'Material Icons'
						font-weight normal

						vertical-align middle
				
					font-weight bold
				.likes:before
					content 'favorite'

					color indianred
				.comments:before
					content 'mode_comment'

					color cornflowerblue
</style>
